export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const CENTER_DATA = {
  'Lonsdale': { id: '68f9a3f8-4927-4808-b91a-68f71a47d771', name: 'Lonsdale', address: '111 3rd St West, North Vancouver', icon: '📍', phone: '(604) 929-7360', hours: 'Mon–Fri 10am–7pm, Sat–Sun 10am–6pm', mapUrl: 'https://maps.google.com/?q=111+3rd+St+West,+North+Vancouver,+BC' },
  'Mountain Hwy': { id: 'bb3035e6-32a2-451a-95ba-de4f281ceb8e', name: 'Mountain Hwy', address: '112-223 Mountain Hwy, North Vancouver', icon: '📍', phone: '(604) 929-2202', hours: 'Mon–Fri 10am–7pm, Sat–Sun 10am–6pm', mapUrl: 'https://maps.google.com/?q=112-223+Mountain+Hwy,+North+Vancouver,+BC' },
  'West Vancouver': { id: '099f4638-5eaa-4528-8730-54ee7b22555b', name: 'West Vancouver', address: '1570 Marine Drive, West Vancouver', icon: '📍', phone: '(604) 912-0131', hours: 'Mon–Fri 10am–7pm, Sat–Sun 10am–6pm', mapUrl: 'https://maps.google.com/?q=1570+Marine+Drive,+West+Vancouver,+BC' }
};

export const EXCLUDED_CATEGORIES = [
  'Addon', 'FREE TRAINING SERVICES', 'voiding service',
  'Test category', 'Other Services', 'Brows',
  'Microblading', 'BLACK FRIDAY', 'Winter Bundles'
];

export const RECAPTCHA_SITE_KEY = '6LeqVwEgAAAAAPzbMEjYkvMQbRaqjdGSlg_hYa-e';

export const RESERVATION_TIMEOUT = 5 * 60;
